@if (templateGroups) {
  <div class="control template-chooser">
    @if (templateGroups.length > 1) {
      <div class="template-group-selection">
        @for (templateGroup of templateGroups | paginate: {
          id: templatePagination,
          itemsPerPage: itemsPerPage,
          currentPage: currentPage
          }; track templateGroup) {
          <div class="template-group"
            (click)="templateGroupClicked(templateGroup.id)">
            <img class="preview-image"
              [attr.data-src]="templateGroup.previewUrl"
              [src]="loadingUrl"
              id="{{templateGroup.id}}" />
            <br />
            <label for="{{templateGroup.id}}">
              {{ templateGroup.title }}
            </label>
          </div>
        }
      </div>
    }
    @if (templateGroups.length === 1) {
      <div class="templates">
        @for (preview of (getTemplatePreviews(templateGroups[0].id) | paginate: {
          id: templatePagination,
          itemsPerPage: itemsPerPage,
          currentPage: currentPage
          }); track trackById($index, preview.template)) {
          <div
            class="template"
            [ngClass]="{'active': preview.template.id === selectedTemplateId}"
            (click)="updateSelectedTemplate(templateGroups[0].id, preview.template.id)"
            >
            <div class="img" #templatePreviewImage>
              <img class="preview-image"
                [src]="preview.previewUrl"
                loading="lazy"
                (error)="onPreviewImageError(preview)"
                />
            </div>
            <!-- eslint-disable-next-line -->
            <label class="title">
              {{ preview.template.title }}
            </label>
          </div>
        }
      </div>
    }
    <pagination-controls  [id]="templatePagination"
      (pageChange)="pageChanged($event)"
      maxSize="6"
      directionLinks="true"
      autoHide="true"
      previousLabel=""
      nextLabel=""
      screenReaderPaginationLabel="Pagination"
      screenReaderPageLabel="page"
      screenReaderCurrentLabel="You're on page"
    ></pagination-controls>
  </div>
}

@if (templateGroupSelection !== undefined) {
  <div #modal class="template-selection"
    >
    <div class="shroud"></div>
    <div class="content">
      <mat-card class="template-groups">
        <mat-card-header>
          <mat-card-title>
            {{ 'i18n.toolbox.layout.title' | translate }}
          </mat-card-title>
          <mat-icon svgIcon="close"
            class="close-x"
          (click)="unsetTemplateGroupSelection()"></mat-icon>
        </mat-card-header>
        <mat-card-content>
          <mat-tab-group color="accent"
            [(selectedIndex)]="templateGroupSelectionIdx"
            >
            @for (templateGroup of templateGroups; track trackById($index, templateGroup)) {
              <mat-tab [label]="templateGroup.title">
                @if (isVisitedTemplateGroup(templateGroup.id)) {
                  <div class="template-list"
                   (swipeleft)="updateSelectedTemplateGroupIndex(
                          templateGroupSelectionIdx + 1)"
                   (swiperight)="updateSelectedTemplateGroupIndex(
                          templateGroupSelectionIdx - 1)"
                    >
                    @for (preview of getTemplatePreviews(templateGroup.id);
                          track trackById($index, preview.template))
                    {
                      <div
                        class="template"
                        [ngClass]="{'active': preview.template.id === selectedTemplateId}"
                        (click)="updateSelectedTemplate(
                                  templateGroup.id, preview.template.id)"
                        >
                        <div class="img" #templatePreviewImage>
                          <img class="preview-image"
                            [src]="preview.previewUrl"
                            loading="lazy"
                            (error)="onPreviewImageError(preview)"
                            [style.borderStyle]="templatesSettings.showTemplatePreviewFrames ? 'solid': 'none'" />
                        </div>
                        <div class="meta">
                          <div class="title">{{ preview.template.title }}</div>
                          @if (placeholdersCount(preview.template) > 0) {
                            <div class="count">
                              {{ 'i18n.toolbox.layout.template.suitableFor' | translate:placeholdersCount(preview.template) }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </mat-tab>
            }
          </mat-tab-group>
        </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button translate
            size="small"
            (click)="unsetTemplateGroupSelection()"
          >i18n.button.cancel</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
}
